<template>
  <form @submit.prevent="submit">
    <b-card>
      <fields :form="form" ungrouped />
    </b-card>

    <div v-if="loaded" role="tablist">
      <b-card v-for="(fieldGroup, index) in fieldGroups" :key="index" no-body>
        <b-card-header class="p-0" role="tab">
          <b-button v-b-toggle="fieldGroup.groupName" block class="text-left">
            {{ $t('vehicles.field_groups.' + fieldGroup.trans) }}
            <span class="float-right">
              <i
                :class="{
                  'icon-arrow-down32': !fieldGroup.visible,
                  'icon-arrow-up32': fieldGroup.visible,
                }"
              ></i>
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          :id="fieldGroup.groupName"
          accordion="prices"
          role="tabpanel"
          @input="visible => (fieldGroup.visible = visible)"
        >
          <b-card-body class="mt-4">
            <div
              v-if="fieldGroup.groupName === 'standard'"
              v-show="model.is_fixed"
            >
              <field name="pricing.fixed_price" />
            </div>

            <fields :form="form" :group="fieldGroup.groupName" @input="onChangeDayNightFieldsComponentType"/>

            <div v-if="fieldGroup.groupName === 'day_night'">
              <per-day-prices
                :form="form"
                field-name-template="pricing.days.{day}"
              />
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <!--    <input v-model="noConflictCheck" type="hidden" name="no-conflict-check" />-->
    <b-button type="submit" variant="primary">
      {{ $t('general.save') }}
    </b-button>
    <b-button type="button" variant="light" class="ml-2" @click="cancel">
      {{ $t('general.cancel') }}
    </b-button>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import PerDayPrices from '../PerDayPrices'

export default {
  name: 'ZoneToZonePriceForm',

  components: {
    PerDayPrices,
  },

  mixins: [ResourceFormMixin],

  props: {
    vehicleId: { type: [Number, String], required: true },
    editId: { type: [Number, String], required: false, default: null },
    apiInterface: { type: Object, required: true },
    rideType: { type: String, required: true },
  },

  data() {
    return {
      base: 'zone-to-zone-pricing',
      fieldGroups: [
        { groupName: 'standard', trans: 'standard', visible: false },
        {
          groupName: 'additional',
          trans: 'additional',
          visible: false,
        },
        { groupName: 'day_night', trans: 'day_night', visible: false },
        {
          groupName: 'payment_methods',
          trans: 'payment_methods',
          visible: false,
        },
      ],
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
      ],
      periods: [
        'day',
        'night',
      ],
      loaded: false,
    }
  },

  computed: {
    form() {
      return this
    },
  },
  watch: {
    id() {
      this.load()
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    api() {
      return this.apiInterface
    },

    submit() {
      this.save()
        .then(result => {
          this.$toast.success(result.message)
        })
        .catch(({ data }) => {
          if (data && data.conflicting) {
            this.$alert.warning(data.message, '', {
              showCancelButton: true,
              confirmButtonText: this.$t('general.save'),
              preConfirm: force => {
                if (!force) {
                  return
                }

                this.apiInterface.setParameter('no-conflict-check', 1)
                this.save().finally(() => {
                  this.apiInterface.removeParameter('no-conflict-check')
                })
              },
            })
          }
        })
    },
    cancel() {
      this.$emit('cancel')
    },
    load() {
      this.loaded = false
      this.loadForm().then(() => {
        this.loaded = true
        this.model.ride_type = this.rideType

        // set day/night fields component types initially
        this.setDayNightFieldsComponentType(this.model.pricing.days_metric)
      })
    },



    setDayNightFieldsComponentType(selectedDaysMetric) {
      // filter day_night pricing fields
      let dayNightPricingAttrs = this.fields.list.filter(field =>
        this.days.some(day =>
          this.periods.some(period => field.attribute === `pricing.days.${day}.${period}`)
        )
      );

      // change dayNightPricingAttrs component type`s based on pricing.days_metric`s select field
      if (selectedDaysMetric === 'fixed' || selectedDaysMetric === 'surcharge') {
        dayNightPricingAttrs.map(field => field.component = 'price-in-selected-currency-field')
      } else {
        dayNightPricingAttrs.map(field => field.component = 'number-field')
      }
    },

    onChangeDayNightFieldsComponentType(fieldData) {
      this.setDayNightFieldsComponentType(fieldData.value)
    },

  },
}
</script>
